import { define } from 'hooked-elements'
import * as widont from 'widont'

define('[data-component~="widont"]', element => {
  element.innerHTML = widont(element.innerHTML)
})